/**
 * Registry of data-testid values for e2e and integration tests.
 * Single source of truth: components read ids from here, never hard-code the strings.
 * Grouped by screen and flow; parameterised ids come from the helpers below.
 */
export const testIds = {
  page: {
    root: 'page-root',
  },
  layout: {
    header: 'layout-header',
    footer: 'layout-footer',
  },
  consignmentForm: {
    root: 'consignment-form',
    errorSummary: 'consignment-error-summary',
    itemsHeader: 'consignment-items-header',
    direction: 'consignment-direction',
    estimate: 'consignment-estimate',
    submit: 'consignment-submit',
  },
} as const

export const testIdHelpers = {
  /** id for repeated list items, e.g. table rows */
  listItem: (prefix: string, index: number) => `${prefix}-${index}`,
}
